let VCA = VCA || {};

VCA.ForgotPassword = (function ($) {

    let ui = {};
    let emailValid = false;

    function cacheUI() {
        ui.$ForgotPasswordForm = $('#ForgotPasswordForm');
        ui.$ForgotPasswordInput = $('#ForgotPasswordEmail');
        ui.$InputContainer = $('.acct-forgot-password__main');
        ui.$SubmitBtn = $('#ForgotPasswordSubmitBtn');
        ui.$NavRedirectBtnContainer = $('.acct-forgot-password__nav-redirect');
        ui.$UnsuccessfulErrMsg = $('.acct-forgot-password__be-error-msg');
        ui.$SuccessMsg = $('.acct-forgot-password__be-success-msg');
    }
    
    function bindEvents() {
        ui.$ForgotPasswordInput.on('blur', validateEmailAddress);
        ui.$ForgotPasswordInput.on('keyup paste', hideErrorMessages);
        ui.$ForgotPasswordForm.on('submit', submitForm);
    }

    function hideErrorMessages(e) {
        const el = $(e.currentTarget);
        el.removeClass('has-error');
        el.parent().find('.input-error-text').hide();

        ui.$UnsuccessfulErrMsg.hide();
        ui.$SuccessMsg.hide();
    }

    function checkIfErrorMsgIsPresent() {
        let errorMsg = ui.$UnsuccessfulErrMsg.html().trim();

        if (errorMsg.length == 0) {
            ui.$UnsuccessfulErrMsg.hide();
        } else {
            ui.$InputContainer.addClass('adjust-margin');
            ui.$ForgotPasswordInput.addClass('has-error');
            ui.$UnsuccessfulErrMsg.show();
        }
    }

    function checkIfSuccessMsgIsPresent() {

        let successMsg = ui.$SuccessMsg.html().trim();

        if (successMsg.length == 0) {
            ui.$SuccessMsg.hide();
        } else {
            ui.$InputContainer.addClass('adjust-margin');
            ui.$SuccessMsg.show();
            window.VCA.AccountDatalayer.dataLayerForgotPasswordSuccess();
        }
    }

    function validateEmailAddress() {
        let email = ui.$ForgotPasswordInput.val();
        let emailRegex = /\S+@\S+\.\S+/;
        let validateEmail = emailRegex.test(email);

        ui.$ForgotPasswordInput.attr('value',email);

        if (email.trim() == '') {
            ui.$ForgotPasswordInput.addClass('has-error');
            ui.$ForgotPasswordInput.parent().find('.error-msg.required').show();
            ui.$ForgotPasswordInput.parent().find('.input-error-text').show();
        } else {
            ui.$ForgotPasswordInput.parent().find('.error-msg').hide();

            if (validateEmail) {
                ui.$ForgotPasswordInput.removeClass('has-error');
                ui.$ForgotPasswordInput.parent().find('.input-error-text').hide();
                emailValid = true;
            } else {
                ui.$ForgotPasswordInput.addClass('has-error');
                ui.$ForgotPasswordInput.parent().find('.error-msg.invalid').show();
                ui.$ForgotPasswordInput.parent().find('.input-error-text').show();
                emailValid = false;
            }
        }
    }
    
    function submitForm(e) {
        validateEmailAddress();

        if (emailValid) {
            return true;
        } else {
            e.preventDefault();
            return false;
        }
    }

    function init() {
        if ($('.acct-forgot-password').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
        checkIfErrorMsgIsPresent();
        checkIfSuccessMsgIsPresent();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ForgotPassword.init();
});